import { ContactsContainer as Contacts } from "./contacts.container";

// Default export needed
// eslint-disable-next-line import/no-default-export
export default Contacts;
